import React, { useEffect, useState } from "react";
import { Card, Col, Modal, Row } from "react-bootstrap";

import { Common } from "../../../../helper";
import { LoadingSpinner, VennDiagramComponent } from "../../";
import { isEmptyObject } from "../../../../util";
import * as dashboardApi from "../../../../api/dashboardApi";

const PredictedPass = (props) => {
  const { classOptions } = props;
  const [selectedClass, setSelectedClass] = useState();
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);

  useEffect(() => {
    getResultant(classOptions[0].value)
  }, []);

  const getResultant = async (classId) => {
    setIsLoading(true);
    const details = await dashboardApi.getOverallPredictedPassRate({ classId });
    if (!isEmptyObject(details.Items)) {
      setData(details.Items)
    }
    setIsLoading(false);
  }

  return (
    <>
      <Card className='radialProgressMain'>
        <Row>
          <Col>
            <p className='topic'>{Common.PredictedPassRate}</p>
            <p className='subTopic'>{Common.PredictedPassRateSubTitle}</p>
          </Col>
          <Col className='dropDownZone'>
            <select className='dropDownResult' defaultValue={selectedClass} onChange={(e) => { setSelectedClass(e.target.value); getResultant(e.target.value) }} >
              {
                classOptions?.map((item) => {
                  return (<option key={item.value} value={item.value}>{item.label}</option>)
                })
              }
            </select>
          </Col>
        </Row>
        {isLoading ? <LoadingSpinner /> : <Row className="d-flex justify-content-center">
          <button className="d-flex align-items-center" onClick={() => setOpenViewModal(true)} style={{width:"380px",background:"none"}}>
            {data && <VennDiagramComponent subjects={data} />}
          </button>
        </Row>}
      </Card>
      <Modal show={openViewModal} className='comment-modalOne' onHide={() => { setOpenViewModal(false); }} backdrop="static" keyboard={false}>
        <Modal.Header className='viewSchoolHeader' closeButton>
          <Col> <span className="d-flex justify-content-center align-items-center topic" >{Common.PredictedPassRate}</span></Col>
        </Modal.Header>
        <Modal.Body className='addEvidenceModalBody'>
          <Row>
            <div>
              <p><span className="d-flex align-items-center"><div className='greenPointer_' style={{ backgroundColor: "rgba(147, 66, 108, 0.50)" }}></div>&nbsp; <span className="subjectHeading">{Common.VennDiagramSubject.MathReadAndWrite} ({data?.mathOrWritingOrReading?.count})</span> </span>
                <ul className='liTags'>
                  {data?.mathOrWritingOrReading?.studentNames?.map((user, index) => (
                    <li key={index}>{user}</li>
                  ))}
                </ul> </p>
              <p><span className="d-flex align-items-center"><div className='greenPointer_' style={{ backgroundColor: "rgba(178, 29, 91, 0.50)" }}></div>&nbsp;<span className="subjectHeading">{Common.VennDiagramSubject.MathAndReading} ({data?.mathsOrReading?.count})</span> </span>
                <ul className='liTags'>
                  {data?.mathsOrReading?.studentNames?.map((user, index) => (
                    <li key={index}>{user}</li>
                  ))}
                </ul> </p>
              <p><span className="d-flex align-items-center"><div className='greenPointer_' style={{ backgroundColor: "rgba(95, 72, 129, 0.50)" }}></div>&nbsp; <span className="subjectHeading">{Common.VennDiagramSubject.MathAndWriting} ({data?.mathOrWritingCount?.count})</span> </span>
                <ul className='liTags'>
                  {data?.mathOrWritingCount?.studentNames?.map((user, index) => (
                    <li key={index}>{user}</li>
                  ))}
                </ul></p>
              <p><span className="d-flex align-items-center"><div className='greenPointer_' style={{ backgroundColor: "rgba(168, 97, 102, 0.50)" }}></div>&nbsp; <span className="subjectHeading">{Common.VennDiagramSubject.ReadingAndWriting} ({data?.readingOrWriting?.count})</span> </span>
                <ul className='liTags'>
                  {data?.readingOrWriting?.studentNames?.map((user, index) => (
                    <li key={index}>{user}</li>
                  ))}
                </ul> </p>
              <p><span className="d-flex align-items-center"><div className='greenPointer_' style={{ backgroundColor: "rgba(105, 3, 117, 0.50)" }}></div>&nbsp; <span className="subjectHeading">{Common.VennDiagramSubject.Math} ({data?.maths?.count})</span> </span>
                <ul className='liTags'>
                  {data?.maths?.studentNames?.map((user, index) => (
                    <li key={index}>{user}</li>
                  ))}
                </ul>
              </p>
              <p><span className="d-flex align-items-center"><div className='greenPointer_' style={{ backgroundColor: "rgba(251, 54, 64, 0.50)" }}></div>&nbsp;  <span className="subjectHeading">{Common.VennDiagramSubject.Reading} ({data?.reading?.count})</span></span>
                <ul className='liTags'>
                  {data?.reading?.studentNames?.map((user, index) => (
                    <li key={index}>{user}</li>
                  ))}
                </ul></p>
              <p><span className="d-flex align-items-center"><div className='greenPointer_' style={{ backgroundColor: "rgba(85, 140, 140, 0.50)" }}></div>&nbsp; <span className="subjectHeading">{Common.VennDiagramSubject.Writing} ({data?.writing?.count})</span> </span>
                <ul className='liTags'>
                  {data?.writing?.studentNames?.map((user, index) => (
                    <li key={index}>{user}</li>
                  ))}
                </ul></p>
              <p ><span className="d-flex align-items-center"><div className='greenPointer_' style={{ backgroundColor: "var(--below-colour)" }}></div>&nbsp; <span className="subjectHeading">{Common.VennDiagramSubject.None} ({data?.fail?.count})</span> </span>
                <ul className='liTags'>
                  {data?.fail?.studentNames?.map((user, index) => (
                    <li key={index}>{user}</li>
                  ))}
                </ul></p>
            </div>
          </Row>
        </Modal.Body>
        <Modal.Footer className='comment-modal-footer'>
          <button className="upload-cancel" type="button" onClick={() => setOpenViewModal(false)}>{Common.Close}</button>
        </Modal.Footer>
      </Modal></>
  );
};

export { PredictedPass };